module.exports = __webpack_public_path__ + "img/weixingxuanju09314-3.prt.dca844a5.jpg";